export default "__VITE_ASSET__DNvJhXkv__"